import * as THREE from '@phdsoft/three';
import { Injectable } from '@angular/core';
import { ThreeJsCleanup } from 'src/app/shared/utils/threejs-cleanup.util';

@Injectable({ providedIn: 'root' })
export class GraphicsLights {
    private light: THREE.AmbientLight;
    private pointLightx: THREE.PointLight;
    private pointLight2: THREE.PointLight;
    private pointLight3: THREE.PointLight;
    private pointLight4: THREE.PointLight;
    private pointLight5: THREE.PointLight;
    private spotLight: THREE.SpotLight;

    constructor() {
        this.initLights();
    }

    // While this service remains global, we cannot destroy the fields that are initialized at the constructor
    // without breaking places that use it. Keep method for reference and use after future refactoring!
    public destroy(): void {
      // Dispose of all lights using ThreeJsCleanup
      [
        this.light, this.pointLightx, this.pointLight2, this.pointLight3,
        this.pointLight4, this.pointLight5, this.spotLight
      ].forEach((light) => {
          ThreeJsCleanup.disposeObject(light);
      });

      // Nullify references to lights
      this.light = null;
      this.pointLightx = null;
      this.pointLight2 = null;
      this.pointLight3 = null;
      this.pointLight4 = null;
      this.pointLight5 = null;
      this.spotLight = null;
  }

  private initLights() {
    const lightColor = 0xffffff; // 0xf0f0f0;
    // Prod (three r117) intensities converted to physical units (x PI). The point lights use decay 0:
    // r117 applied no falloff to a light with distance 0, so they reached the model at full strength
    // from their own directions and shaded each face differently. With decay 2 they were ~0 at 1000 and
    // the ambient light alone painted every face the same colour (light model: flat silhouette).
    // was: this.light = new THREE.AmbientLight(lightColor, 3.0); // Increased from 0.7 for physically correct lighting
    this.light = new THREE.AmbientLight(lightColor, 0.5 * Math.PI); // prod 0.7, lowered for the sRGB output's contrast
    // was: this.pointLightx = new THREE.PointLight(0xffffff, 2.5); // Increased from 0.45
    this.pointLightx = new THREE.PointLight(0xffffff, 0.45 * Math.PI, 0, 0);
    this.pointLightx.position.x = 0;
    this.pointLightx.position.z = 1000;
    this.pointLightx.position.y = 0;
    // was: this.pointLight2 = new THREE.PointLight(0xffffff, 2.0); // Increased from 0.40
    this.pointLight2 = new THREE.PointLight(0xffffff, 0.40 * Math.PI, 0, 0);
    this.pointLight2.position.x = 1000;
    this.pointLight2.position.z = 0;
    this.pointLight2.position.y = 0;
    // was: this.pointLight3 = new THREE.PointLight(0xffffff, 1.8); // Increased from 0.35
    this.pointLight3 = new THREE.PointLight(0xffffff, 0.35 * Math.PI, 0, 0);
    this.pointLight3.position.x = -1000;
    this.pointLight3.position.z = 0;
    this.pointLight3.position.y = 0;
    // was: this.pointLight4 = new THREE.PointLight(0xffffff, 1.0); // Increased from 0.15
    this.pointLight4 = new THREE.PointLight(0xffffff, 0.15 * Math.PI, 0, 0);
    this.pointLight4.position.x = 0;
    this.pointLight4.position.z = 0;
    this.pointLight4.position.y = 1000;
    // was: this.pointLight5 = new THREE.PointLight(0xffffff, 1.0); // Increased from 0.15
    this.pointLight5 = new THREE.PointLight(0xffffff, 0.15 * Math.PI, 0, 0);
    this.pointLight5.position.x = 0;
    this.pointLight5.position.z = 0;
    this.pointLight5.position.y = -1000;
    this.spotLight = new THREE.SpotLight(lightColor, 2.5); // Increased from 0.40
    this.spotLight.distance = 1800; // Increased distance to ensure it reaches
    this.spotLight.angle = .8;
    this.spotLight.penumbra = 1;
    this.spotLight.decay = 1; // Lower decay for better reach, or keep 2 and boost intensity more. 
    // Keeping decay 2 (physical) but boosting intensity is better, but older scenes often used default decay 1. 
    // Let's try decay 2 with high intensity or decay 0/1. 
    // Three.js default decay is 2 now.
    // const geometry = new THREE.BufferGeometry();
        // geometry.setAttribute('position', new THREE.Float32BufferAttribute([0, 0, 0], 3));

        // const material = new THREE.PointsMaterial({ color: 0x888888 });
        // this.spotlightElement = new THREE.Points(geometry, material);
        // this.spotlightElement.visible = false;
        // this.spotLight.target = this.spotlightElement;

    }

    public addLights(scene: THREE.Scene, camera: THREE.Camera, controls: any) {

        // this.spotLight.position.copy(camera.position.clone().add(new THREE.Vector3(0, 0, 0)));
        // this.spotLight.lookAt(controls.target.clone().add(new THREE.Vector3(0, 0, 0)));
        scene.add(this.light);
        scene.add(this.pointLightx);
        scene.add(this.pointLight2);
        scene.add(this.pointLight3);
        scene.add(this.pointLight4);
        scene.add(this.pointLight5);
        // scene.add(this.spotLight);
    }

    public setSpotlightFromCamera(camera: THREE.Camera) {
      camera.add(this.spotLight);
      this.spotLight.position.set(0, 0, 1);
      this.spotLight.target = camera;
      return this.spotLight;
    }
}
